<div role="button" class="number-panel overs" matRipple (click)="incrementOvers()" tabindex="0">
    <div class="number-display">
        {{ overCount() | number: '2.0-0' }}
    </div>
    <div class="label">
        Overs
    </div>
</div>

<div role="button" class="number-panel balls" matRipple (click)="incrementBalls()" tabindex="0">
    <div class="number-display">
        {{ ballCount() | number: '1.0-0' }}
    </div>
    <div class="label">
        Balls
    </div>
</div>